<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col>
        <h1>Создание короткой ссылки</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <short-urls-form redirect=true @onSubmit="submit"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ShortUrlsForm from '../../../components/shortUrls/ShortUrlsForm';

import {mapActions} from "vuex";

export default {
  name: 'Create',
  data: () => ({
    page: {
      title: "Создание короткой ссылки"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Короткие ссылки",
        disabled: true,
        to: '/shortuls'
      },
      {
        text: "Создание",
        disabled: true,
        to: '/shortuls/edit'
      },
    ],
  }),
  components: {ShortUrlsForm},
  methods: {
    ...mapActions({
      storeItem: 'ShortUrls/storeItem',
    }),
    submit(payload) {
      this.storeItem(payload).then(() => {});
    }
  }
}
</script>
